<span [class]="'badge ' + (type === 'small' ? ' small ' : '') + bgColor + ' ' + fontSize + ' ' + fontColor + (border ? ' border' : '') + ' ' + brdColor + ' ' + (rounded ? ' rounded-pill' : '')" appTranslate><ng-content></ng-content></span>
